import { fetchWithRetry } from './util.js';

export async function whoisLookup(ip) {
  try {
    const res = await fetchWithRetry(`https://rdap.arin.net/registry/ip/${ip}`);
    if (!res.ok) {
      const fallback = await fetchWithRetry(`https://rdap.db.ripe.net/ip/${ip}`);
      if (!fallback.ok) {
        const lacnic = await fetchWithRetry(`https://rdap.lacnic.net/rdap/ip/${ip}`);
        if (!lacnic.ok) {
          const apnic = await fetchWithRetry(`https://rdap.apnic.net/ip/${ip}`);
          if (!apnic.ok) return null;
          return parseRDAP(await apnic.json());
        }
        return parseRDAP(await lacnic.json());
      }
      return parseRDAP(await fallback.json());
    }
    return parseRDAP(await res.json());
  } catch (err) {
    console.warn('[whois] lookup failed for', ip, err.message);
    return null;
  }
}

function parseRDAP(data) {
  const entities = data?.entities || [];
  const org = entities.find(e => e.roles?.includes('registrant') || e.roles?.includes('org'));
  const abuse = entities.find(e => e.vcardArray?.[1]?.some?.(v => v[0] === 'kind'));

  const getName = (entity) => {
    const vcard = entity?.vcardArray?.[1];
    if (!vcard) return '';
    const fn = vcard.find(v => v[0] === 'fn');
    return fn?.[3] || '';
  };

  const getEmail = (entity) => {
    const vcard = entity?.vcardArray?.[1];
    if (!vcard) return '';
    const email = vcard.find(v => v[0] === 'email');
    return email?.[3] || '';
  };

  const events = data?.events || [];
  const registration = events.find(e => e.eventAction === 'registration');
  const lastChanged = events.find(e => e.eventAction === 'last changed');

  let country = data?.country || '';
  if (!country && org) {
    const vcard = org?.vcardArray?.[1];
    if (vcard) {
      const adr = vcard.find(v => v[0] === 'adr');
      if (adr && adr[3]) {
        const parts = adr[3];
        country = parts[parts.length - 1] || country;
      }
    }
  }

  return {
    handle: data?.handle || '',
    name: org ? getName(org) : '',
    country,
    abuseEmail: abuse ? getEmail(abuse) : '',
    registrationDate: registration?.eventDate || '',
    lastChangedDate: lastChanged?.eventDate || '',
    cidr: (data?.cidr0_cidrs || []).map(c => `${c.v4prefix}/${c.length}`).join(', '),
    startAddress: data?.startAddress || '',
    endAddress: data?.endAddress || '',
    raw: data,
  };
}

export async function whoisViaWorker(ip, workerUrl) {
  try {
    const res = await fetch(`${workerUrl}/whois`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ip }),
    });
    if (!res.ok) return null;
    return res.json();
  } catch (err) {
    console.warn('[whois] worker lookup failed for', ip, err.message);
    return null;
  }
}
